import { AfterConsentsSaved } from './events/after_consents_saved';

export class ConsentsAnalytics {
    constructor() {
        new AfterConsentsSaved();
    }
}
